import React, { useState } from 'react';
import { Modal, Transfer, Button, Row, Col, message } from 'antd';
import { useDispatch } from 'react-redux';
import { DownloadOutlined } from '@ant-design/icons';

import { updateExportColumns } from '../../store/reducers/employeeSlice';

var fileDownload = require('js-file-download');

const EmployeeExport = ({ grid, columns, showModal, setShowModal }) => {
  const dispatch = useDispatch();
  const [exportInProgress, setExportInProgress] = useState(false);

  const onExport = (onFinish) => {
    setExportInProgress(true);
    console.log('onExport Clicked');
    fetch(`${process.env.REACT_APP_API_BASE_URL}/employees/export`, {
      method: 'POST',
      cache: 'no-cache',
      headers: new Headers({
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      }),
      body: JSON.stringify({
        gridId: grid.id,
        filters: grid.metaData.filters,
        sort: grid.metaData.sorting,
        exportColumns: grid.metaData.exportColumns,
      }),
    })
      .then((response) => {
        if (response.status === 200) {
          return response.blob();
        } else {
          onFinish('error');
          throw new Error('Error');
        }
      })
      .then((blob) => {
        fileDownload(
          blob,
          `exployees-${grid.id}-${new Date()
            .toLocaleString()
            .replaceAll('/', '-')
            .replace(',', '')
            .replaceAll(' ', '_')}.xlsx`
        );
        setExportInProgress(false);
      })
      .catch((e) => {
        setExportInProgress(false);
        message.error('Something went wrong, Please try again!');
      });
  };

  const getExportTargetKeys = (columns, exportColumns) => {
    const exportableColumns = columns.filter((column) => {
      return (
        grid.metaData.exportColumns.findIndex(
          (vc) => vc.column === column.serverKey
        ) > -1
      );
    });
    console.log(
      'Exportable columns ///',
      exportableColumns.map((column) => column.key)
    );
    return exportableColumns.map((column) => column.key);
  };

  const handleSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
    // this.setState({ selectedKeys: [...sourceSelectedKeys, ...targetSelectedKeys] });

    console.log('sourceSelectedKeys: ', sourceSelectedKeys);
    console.log('targetSelectedKeys: ', targetSelectedKeys);
  };

  const handleChange = (nextTargetKeys, direction, moveKeys) => {
    const exportColumns = columns
      .filter((column) => nextTargetKeys.includes(column.key))
      .map((column) => {
        return {
          column: column.serverKey,
          dataType: column.dataType,
        };
      });

    dispatch(updateExportColumns({ gridId: grid.id, exportColumns }));

    console.log('targetKeys: ', nextTargetKeys);
    console.log('direction: ', direction);
    console.log('moveKeys: ', moveKeys);
    console.log('exportColumns', exportColumns);
  };

  return (
    <Modal
      title="Export Employees"
      visible={showModal}
      confirmLoading={false}
      destroyOnClose={true}
      onCancel={() => setShowModal(false)}
      centered
      style={{ maxWidth: '800px' }}
      width="80%"
      footer={null}
      maskClosable={false}
    >
      <Row>
        <Col xs={24} md={17}>
          <Transfer
            listStyle={{ width: 225 }}
            dataSource={columns.map((column) => {
              return {
                key: column.key,
                title: column.title,
                disabled: false,
              };
            })}
            titles={['Available Fields', 'Fields To Export']}
            targetKeys={getExportTargetKeys(
              columns,
              grid.metaData.exportColumns
            )}
            // targetKeys={columns.map((column) => column.key)}
            // selectedKeys={getExportSelectedKeys(
            //   columns,
            //   grid.metaData.exportColumns
            // )}
            onChange={handleChange}
            onSelectChange={handleSelectChange}
            render={(item) => item.title}
            // disabled={disabled}
            oneWay
            style={{ marginBottom: 16 }}
          />
        </Col>
        <Col xs={24} md={7}>
          <Button
            type="primary"
            loading={exportInProgress}
            disabled={
              exportInProgress || grid.metaData.exportColumns.length <= 0
            }
            onClick={onExport}
            icon={<DownloadOutlined />}
          >
            Export
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default EmployeeExport;
